import { PostMessageRequest } from "./types";

export class PostMessageRepository {
    private postMessageRequests: Map<string, PostMessageRequest>;

    constructor() {
        this.postMessageRequests = new Map();
    }

    public storePostMessageRequest(postMessageRequest: PostMessageRequest): void {
        this.postMessageRequests.set(postMessageRequest.responseIdentifier, postMessageRequest);
        postMessageRequest.status = 'CREATED';
    }

    public getPostMessageRequests(): PostMessageRequest[] {
        return Array.from(this.postMessageRequests.values());
    }

    public getPostMessageRequest(responseIdentifier: string): PostMessageRequest | undefined {
        return this.postMessageRequests.get(responseIdentifier);
    }

    public getResponseIdentifiers(): PostMessageRequest['responseIdentifier'][] {
        return Array.from(this.postMessageRequests.keys());
    }

    public getPostMessageRequestStatus(responseIdentifier: string): PostMessageRequest['status'] {
        return this.postMessageRequests.get(responseIdentifier)?.status ?? 'UNDEFINED';
    }

    public setPostMessageRequestStatus(responseIdentifier: string, status: PostMessageRequest['status']): void {
        const request = this.postMessageRequests.get(responseIdentifier);
        if (request) {
            request.status = status;
        }
    }

    public deletePostMessageRequest(responseIdentifier: string): void {
        this.postMessageRequests.delete(responseIdentifier); 
    }
}